import {
  ChevronDownIcon,
  ChevronUpDownIcon,
  ChevronUpIcon,
} from "@heroicons/react/20/solid";

const SECTION_LABEL_CLASS =
  "mr-2 shrink-0 text-sm font-semibold text-indigo-600";

const SORT_ICON_BASE =
  "-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-gray-400 group-hover:text-gray-500";

const SORT_OPTIONS = [
  { id: "provider_name", label: "Vendor" },
  { id: "document_date", label: "Document Date" },
];

function SortDirectionIcon({ columnId, sortConfig }) {
  const config = sortConfig?.[columnId];
  if (!config?.direction) {
    return (
      <ChevronUpDownIcon aria-hidden="true" className={SORT_ICON_BASE} />
    );
  }
  if (config.direction === "asc") {
    return (
      <ChevronUpIcon
        aria-hidden="true"
        className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-indigo-600"
      />
    );
  }
  return (
    <ChevronDownIcon
      aria-hidden="true"
      className="-mr-1 ml-1 h-5 w-5 flex-shrink-0 text-indigo-600"
    />
  );
}

/**
 * Sort controls styled like Document Library filter popover triggers (no dropdown).
 */
export default function DocumentLibrarySortBar({ sortConfig, onSort, compact = false }) {
  const buttonPadding = compact ? "px-2 sm:px-3" : "px-4";

  return (
    <section aria-label="Sort documents" className="shrink-0">
      <div className="bg-white py-1">
        <div className="flex items-center">
          <span className={SECTION_LABEL_CLASS}>Sort:</span>
          <div className="flow-root">
            <div className="flex items-center divide-x divide-gray-200">
            {SORT_OPTIONS.map((option) => {
              const isActive = Boolean(sortConfig?.[option.id]?.direction);
              return (
                <button
                  key={option.id}
                  type="button"
                  onClick={() => onSort(option.id)}
                  className={`group inline-flex justify-center ${buttonPadding} text-left text-sm font-medium hover:text-gray-900 ${
                    isActive ? "text-gray-900" : "text-gray-700"
                  }`}
                  aria-pressed={isActive}
                >
                  <span>{option.label}</span>
                  <SortDirectionIcon columnId={option.id} sortConfig={sortConfig} />
                </button>
              );
            })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
